import dayjs from "dayjs";

export type Period = "week" | "month";

export const getDateFromPeriod = (period: Period) => {
  const daysAgo = period === "week" ? 7 : 30;

  return dayjs(new Date())
    .subtract(daysAgo - 1, "day")
    .format("YYYY-MM-DD");
};
